import React, { useCallback, useState } from 'react';
import { ModalTitle } from '@strava/ui/Modal';
import FindFacebookFriends from 'components/shared/friends/FindFacebookFriends';
import { ONBOARDING } from 'components/shared/friends/utils/friendsConstants';
import { useOnboardingContext } from '../../../../state/OnboardingContext';
import { t } from '../../../../shared/onboardingUtils';
import useNavigateToNextStep from '../../../../shared/useNavigateToNextStep';
import ActionButton, { ACTIONS } from '../../../ActionButton/ActionButton';
import OnboardingModalActions from '../../../OnboardingModalActions';
import OnboardingFacepile from '../../../OnboardingFacepile';
import ModalBodyWithAlerts from '../../../ModalBodyWithAlerts';

import styles from './FacebookFriends.scss';

const FacebookFriends = () => {
  const { state, track, dispatch } = useOnboardingContext();
  const { alert, fbAppId, fbVersion, locale, currentAthlete } = state;
  const { stepForward, isProcessing } = useNavigateToNextStep({
    state,
    dispatch,
    track
  });
  const [isSkipBtn, setIsSkipBtn] = useState(true);
  const [facepileAthletes, setFacepileAthletes] = useState([]);

  const handleFollowingFriendsChange = useCallback((followedFriends) => {
    const friendList = Object.values(followedFriends);
    setFacepileAthletes(friendList);
    if (friendList.length > 0) {
      setIsSkipBtn(false);
    }
  }, []);

  return (
    <>
      <ModalTitle id="onboarding-step-title">{t('facebook.title')}</ModalTitle>
      <ModalBodyWithAlerts alert={alert}>
        <FindFacebookFriends
          track={track}
          currentAthlete={currentAthlete}
          source={ONBOARDING}
          fbApiProps={{
            appId: fbAppId,
            version: fbVersion,
            locale
          }}
          onFollowingFriendsChange={handleFollowingFriendsChange}
        />
      </ModalBodyWithAlerts>
      <OnboardingModalActions className={styles.modalActions}>
        <OnboardingFacepile athletes={facepileAthletes} />
        <ActionButton
          className={styles.ctaButton}
          variant={isSkipBtn ? 'default' : 'primary'}
          onClick={() =>
            stepForward({
              analyticsElement: isSkipBtn ? ACTIONS.skip : ACTIONS.next
            })
          }
          data-cy="facebook-friends-next-step-btn"
          isProcessing={isProcessing}
        >
          {t(`cta_actions.${isSkipBtn ? 'skip' : 'continue'}`)}
        </ActionButton>
      </OnboardingModalActions>
    </>
  );
};

export default FacebookFriends;
